import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  mobileApp: 'Mobile App',
  mobileAppDesc:
    'All payment processing fees for cards accepted with Zeller App are inclusive of GST.',
  cardPresentPayments: 'Card Present Payments',
})
